import React from 'react'

import cn from './Tile.module.scss'

type TilePropsType = {
  text: string
  handleClickTile: () => void
}

function Tile(props: TilePropsType) {
  const { text, handleClickTile } = props

  return (
    <div className={cn.tile} onClick={handleClickTile}>
      <div className={cn.inner}>
        <span>{text}</span>
      </div>
    </div>
  )
}

export default React.memo(Tile)
